<template>
  <b-modal 
    id="modal-1"
    ref="modal"
    :title="title"
    @show="toggleModal"
    @hidden="resetModal"
    @ok="handleOk"
    :ok-title="btnTitle"
    hide-footer
    cancel-title="Отмена"
    cancel-variant="light"
    footer-class="justify-content-between"
  >
    <validation-observer ref="observer" v-slot="{ handleSubmit }">
      <b-form ref="form" @submit.stop.prevent="handleSubmit(submit)">
        <b-button type="submit" variant="success" size="lg" block>
          <span v-if="subject.isFree">Записаться</span>
          <span v-else>Купить</span>
        </b-button>
      </b-form>
    </validation-observer>
    <b-button type="submit" variant="light" size="lg" block @click="hideModal" class="mt-2">
      Отмена
    </b-button>
    <br v-if="!subject.isFree">
    <p class="text-center" v-if="!subject.isFree">Оплачивая пакет, вы автоматически соглашаетесь с условиями предоставления услуг</p>
  </b-modal>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    subject: [Object]
  },
  data () {
    return {
      form: {
      }
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user
    }),
    title () {
      if (this.subject) {
        if (this.subject.isFree) {
          return 'Записаться на ' + this.subject.title
        } else {
          return 'Купить ' + this.subject.title
        }
      }
    },
    btnTitle () {
      if (this.item) {
        return 'Сохранить'
      } else {
        return 'Создать'
      }
    }
  },
  methods: {
    getValidationState ({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null
    },
    submit () {
      this.$store.dispatch('ADD_SUBJECT_TO_STUDENT', { student: this.user.id, subject: this.subject.slug }).then((response) => {
        // this.submitted = true
        // this.$emit('update')
        this.$store.dispatch('GET_USER').then(() => {
          this.$router.push({ name: 'purchased-subject', params: { id: this.subject.slug } })
        })
        this.$nextTick(() => {
          this.$refs.modal.hide()
        })
      }, error => {
        console.log(error)
      })
    },
    resetModal () {
    },
    showModal () {
      this.$refs['modal'].show()
    },
    hideModal () {
      this.$refs['modal'].hide()
    },
    toggleModal () {
      this.resetModal()
      this.$refs['modal'].show()
    },
    handleOk (bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.handleSubmit()
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  created () {
  }
}
</script>